"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemovePhotoTrashIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const RemovePhotoTrashIcon = () => {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "25", height: "24", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M16.5 1a1 1 0 0 1 1 1v3h4a1 1 0 1 1 0 2h-1v12c0 1.654-1.346 3-3 3h-9c-1.654 0-3-1.346-3-3V7h-1a1 1 0 1 1 0-2h4V2a1 1 0 0 1 1-1zm2 6h-11v12c0 .551.448 1 1 1h9c.552 0 1-.449 1-1V7zm-8 2a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm5 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm0-6h-5v2h5V3z", fill: "#FFF", "fill-rule": "evenodd" }) }));
};
exports.RemovePhotoTrashIcon = RemovePhotoTrashIcon;
